// extracted by mini-css-extract-plugin
export default {"user":"styles_user__J2qqi","edit":"styles_edit__RVK77","delete":"styles_delete__a3vx+","table_container":"styles_table_container__SWrTl","userImage":"styles_userImage__9BTCq"};